// extracted by mini-css-extract-plugin
export default {"root":"style_root__wGhfI","headingWrap":"style_headingWrap__9UnYT","heading":"style_heading__E1LcY","codes":"style_codes__YRm43"};